/**
 * The phases a dumbapp execution goes through, in order.
 *
 * They are defined in this way so that we can both use the keys in order
 * at runtime, and TypeScript can derive types from it.
 */
export const phases = Object.freeze({
    /**
     * Prepare a new request by setting a timestamp and determining the correct dumbapp.
     */
    prepareRequest: null,
    /**
     * Prepare the user's wallet, and create a unique ID for the submission.
     *
     * There must be exactly one handler.
     */
    prepareWallet: null,
    /**
     * Additional handlers called before user input is collected.
     */
    preInput: null,
    /**
     * Collect user input.
     */
    input: null,
    /**
     * Additional handlers called after user input is collected.
     */
    postInput: null,
    /**
     * Resolve all dumbapp arguments needed for the smart contract function calls.
     */
    resolve: null,
    /**
     * Load contract data for all steps if applicable.
     */
    loadContracts: null,
    /**
     * Additional handlers called after arguments are resolved, before the dumbapp is
     * executed.
     */
    preExecute: null,
    /**
     * Execute the dumbapp.
     *
     * There must be exactly one handler.
     */
    execute: null,
    /**
     * Act on an execution result, either success or failure.
     */
    result: null,
});
